import { datadogRum } from '@datadog/browser-rum'
import axios from 'axios'

export async function initDatadog () {
  let version = '0.1.0'

  try {
    const response = await axios.get('/version.json')
    version = response.data.version
  } catch (error) {
    console.warn('Não foi possível obter a versão da aplicação.', error)
  }

  const buildAllowedTracingUrls = () => {
    const apiBaseUrls = [
      process.env.VUE_APP_ROOT_API
    ];
    const origins = new Set();
    apiBaseUrls.forEach((baseUrl) => {
      if (!baseUrl) return;
      try {
        origins.add(new URL(baseUrl).origin);
      } catch (error) {
        console.warn(`URL de API ignorada no tracing do Datadog (invalida): ${baseUrl}`, error);
      }
    });
    return Array.from(origins).map((origin) => ({
      match: origin,
      propagatorTypes: ['datadog']
    }));
  };

  if (
    !process.env.VUE_APP_DATADOG_APP_CLIENT ||
    !process.env.VUE_APP_DATADOG_APP_TOKEN
  ) {
    console.warn('Datadog RUM não configurado.')
    return
  }

  datadogRum.init({
    applicationId: process.env.VUE_APP_DATADOG_APP_CLIENT,
    clientToken: process.env.VUE_APP_DATADOG_APP_TOKEN,
    site: 'datadoghq.com',
    service: 'portal-admin',
    env: process.env.NODE_ENV,
    version,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 5,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    allowedTracingUrls: buildAllowedTracingUrls(),
    traceSampleRate: 100,
    defaultPrivacyLevel: 'mask-user-input',
  })
  datadogRum.startSessionReplayRecording()
}
